import { render, staticRenderFns } from "./DesktopViewNew.vue?vue&type=template&id=d03fce18&scoped=true&"
import script from "./DesktopViewNew.vue?vue&type=script&lang=js&"
export * from "./DesktopViewNew.vue?vue&type=script&lang=js&"
import style0 from "./DesktopViewNew.vue?vue&type=style&index=0&id=d03fce18&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d03fce18",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VContainer,VDataTable,VIcon})
